import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import { Container, Line } from "./styles";

const Component: FunctionComponent = () => {
  const list = ["22%", "81%", "98%", "75%", "84%"];
  return (
    <Container>
      {list.map((value, index) => (
        <Line $width={value} key={index} />
      ))}
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetPlaceholder";

export const InlinePlusWidgetPlaceholder = styled(Component)``;
